@layer design-system {
  .rectPositive {
    fill: var(--viz-bullish);
  }

  .rectNegative {
    fill: var(--viz-bearish);
  }

  .rectNeutral {
    fill: var(--text-default);
  }
}
